export {default as elementIds} from './elementIds/elementIds'

export const TokenInfo = {
  MBASE: {
    apiId: 'MBASE',
    urlId: 'mbase',
    tokenName: 'MBASE',
    tokenInfo: 'Minebase',
    tokenNameFull: 'Minebase Token',
    emailSupport: 'Our support option is in bottom right of the page',
    convertAmount: 0,
  },
  XON: {
    apiId: 'XON',
    urlId: 'xon',
    tokenName: 'XON',
    tokenInfo: 'XON',
    tokenNameFull: 'XON Token',
    emailSupport: 'Our support option is in bottom right of the page',
    convertAmount: 0,
  },
  VIME: {
    apiId: 'VIME',
    urlId: 'vime',
    tokenName: 'vime',
    tokenInfo: 'VIME',
    tokenNameFull: 'VIME Token',
    emailSupport: 'Our support option is in bottom right of the page',
    convertAmount: 0,
  },
  GNS: {
    apiId: 'GNS',
    urlId: 'gns',
    tokenName: 'GNS',
    tokenInfo: 'GNS',
    tokenNameFull: 'GNS Token',
    emailSupport: 'Our support option is in bottom right of the page',
    convertAmount: 0.25,
  },
  V999: {
    apiId: 'V999',
    urlId: 'v999',
    tokenName: 'V999',
    tokenInfo: 'V999',
    tokenNameFull: 'V999 Token',
    emailSupport: 'Our support option is in bottom right of the page',
    convertAmount: 0.25,
  },
}

export const RegExValidation = {
  emailValidation: {
    regEx:
      /^(([^<>()[\]\\.,;+:\s@\"]+(\.[^<>()[\]\\.,;+:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/, // eslint-disable-line
    message: '+ is not allowed',
  },
  passwordValidation: {
    regEx: /^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d\S]{8,}$/,
    message:
      'Password must be minimum eight characters, at least one uppercase letter and one lowercase letter',
  },
}

export const WhiteListIP = ['202.84.40.244']

export const TokenChain = {
  binance: 'binance',
  ethereum: 'ethereum',
  polygon: 'polygon',
  optimism: 'optimism',
  solana: 'solana',
}
